module.exports = __webpack_public_path__ + "media/images/builder/qr_example2-2699b16cc27c3cd1485c157ce03a3e43.jpg";